import { render, staticRenderFns } from "./mainMobile.vue?vue&type=template&id=6bcabc92"
import script from "./mainMobile.vue?vue&type=script&lang=js"
export * from "./mainMobile.vue?vue&type=script&lang=js"
import style0 from "./mainMobile.vue?vue&type=style&index=0&id=6bcabc92&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports